// NATIVE
import React, { useState, useEffect} from 'react';


// INSTALLED
import { Link } from 'react-router-dom';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import MuiDrawer from '@mui/material/Drawer';
import Collapse from '@mui/material/Collapse';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useDispatch, useSelector } from 'react-redux';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ListItemButton from '@mui/material/ListItemButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { styled, Theme, CSSObject } from '@mui/material/styles';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';


// CUSTOM
import { Box } from '@mui/material';
import { theme } from '../../commons/theme';
import { closeDrawerAction } from '../../store/globals';
import { IconByString } from '../../components/IconByString';
import { LogoPlatform } from '../../components/LogoPlatform';
import { getIndexParentMenu } from '../../commons/utils';




const drawerWidth = 250;

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

export const MenuSidebar = () => {

    const dispatch = useDispatch();

    // REDUX
    const { drawer }:any  = useSelector( (state:any) => state.globals );
    const { user_permissions }:any  = useSelector( (state:any) => state.permissions );



    const [open, setOpen] = useState(false);

    const [selectedItem, setSelectedItem] = useState<any>("");
    const [selectedItemChild, setSelectedItemChild] = useState("");
    
    const [selectedIndex, setSelectedIndex] = useState(1);
    const [selectedIndexChild, setSelectedIndexChild] = useState(1);
    

    const [selected, setSelected] = useState(true);
    const [selectedChild, setSelectedChild] = useState(true);

    const [menuSideBar, setMenuSideBar] = useState([]);

    useEffect(() => {
      setOpen(drawer);
    },[drawer]); 

    useEffect(() => {
      
      const permissions = user_permissions || [];
      setMenuSideBar(permissions);
      
    }, [user_permissions])
    

    useEffect(() => {
      const path = window.location.pathname;
      if( path == '/' ){
          setSelected(true) 
      } else{
         setSelected(false) 
         const value:any = localStorage.getItem('lastSelectedQypht') || 500;
         if (value) {
            const value_int = parseInt(value)
            setSelectedIndex( value_int )
         }
         
      }
    }, []);


    useEffect(() => {
      openItemParentMenu();
    }, []);
   

    const openItemParentMenu = async() => { 
      const path = window.location.pathname;
      if( path !== '/' ){ 

        const indexMenu = await getIndexParentMenu(path);
        setSelectedItem( indexMenu )

      }
    }
    
  
    

    const handleDrawerClose = async() => {
       await dispatch( closeDrawerAction() );
    };

    const handleClick = (index:any):any => {
      
      if (selectedItem === index) {
        setSelectedItem("")
      } else {
        setSelectedItem(index)
      }

    }

    
    const handleClickChild = (index:any):any => {
      
      if (selectedItemChild === index) {
        setSelectedItemChild("")
      } else {
        setSelectedItemChild(index)
      }

    }
    

    const handleListItemClick = (
      event: React.MouseEvent<HTMLDivElement, MouseEvent>,
      index: number
    ) => {
      setSelectedIndex(index);
      setSelectedIndexChild(0);
      localStorage.setItem('lastSelectedQypht', index.toString());
      setSelected(false);
    }; 


    const handleListItemClickChildren = (
      event: React.MouseEvent<HTMLDivElement, MouseEvent>,
      index: number
    ) => {
      setSelectedIndex(0)
      setSelectedIndexChild(index);
      localStorage.setItem('lastSelectedQypht', index.toString());
      setSelectedChild(false);
    };


    const convertIndexValue = (index:number, indexparent:number) => {
      const number1 = index.toString();
      const number2 = indexparent.toString();
      const new_number = number1+number2;
      return parseInt(new_number);
    }

    const activeDashboard = () => {
      setSelected(true);
      setSelectedIndex(500);
    }


     

    return (
      <Drawer variant="permanent" open={open}>
        <DrawerHeader sx={{ justifyContent: 'space-between' }}>
          <LogoPlatform />
            
          <Box
            component="span"
            sx={{
                color: theme.palette.text.primary,
                fontSize: '1.25rem',
                lineHeight: '1.2',
                fontWeight: '600',
                letterSpacing: '0.15px',
                textTransform: 'uppercase',
                transition: 'margin-inline-start 300ms ease-in-out, opacity 300ms ease-in-out',
                opacity: 1,
                marginInlineStart: '10px'
              }}
            >
            Qihotels
          </Box>
           

            <IconButton sx={{ color: theme.palette.text.primary }} onClick={handleDrawerClose}>
              {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>
        </DrawerHeader>
        {/* <Divider sx={{ bgcolor: theme.palette.text.primary }}  /> */}


       
        
        <List>
        

          {
            menuSideBar.length > 0 && menuSideBar.map((item:any, indexf:any) => ( 

              
              <div key={Math.random().toString(36).substring(2,12)}>

                  
                  {
                     item.childrens.length > 0 
                     ?
                      <div  key={indexf}>
                        <ListItemButton onClick={ () => handleClick(indexf) } 
                          selected={ indexf === selectedItem ? true : false }
                          sx={{
                            margin: '2px',
                            borderStartEndRadius: 30,
                            whiteSpace: 'break-spaces', 
                            borderEndEndRadius: 30,
                            '&:selected': {
                              backgroundColor: '#2E263D14', // Set hover color
                            },
                            '&:hover': {
                              backgroundColor: '#2E263D14', // Set hover color
                            },
                          }}
                          >
                          <ListItemIcon sx={{ color: theme.palette.text.primary }} >
                              <IconByString iconName={item.icon}/>
                          </ListItemIcon>  
                          <ListItemText sx={{ color: theme.palette.text.primary }}  primary={item.text} />
                            {indexf === selectedItem ? <ExpandLess sx={{ color: theme.palette.text.primary }} /> : <ExpandMore sx={{ color: theme.palette.text.primary,  }} />}
                          </ListItemButton>
                          <Collapse  in={indexf === selectedItem} timeout="auto" unmountOnExit key={indexf}>
                            <List component="li" disablePadding >
                                {item.childrens.map((item:any, indexChild:any) => ( 
                                   
                                   <>

                                      {
                                        item.childrens && item.childrens.length > 0 
                                        
                                        ? 
                                          
                                          <> 
                                            <ListItemButton onClick={ () => handleClickChild(indexChild) } 
                                            selected={ indexChild === selectedItemChild ? true : false }
                                            sx={{
                                              margin: '2px',
                                              borderStartEndRadius: 30,
                                              whiteSpace: 'break-spaces', 
                                              borderEndEndRadius: 30,
                                              '&:selected': {
                                                backgroundColor: '#2E263D14', // Set hover color
                                              },
                                              '&:hover': {
                                                backgroundColor: '#2E263D14', // Set hover color
                                              },
                                            }}
                                            >
                                            <ListItemIcon sx={{ color: theme.palette.text.primary }} >
                                                <IconByString iconName={item.icon}/>
                                            </ListItemIcon>
                                            <ListItemText sx={{ color: theme.palette.text.primary }}  primary={item.text}  />
                                              {indexChild === selectedItemChild ? <ExpandLess sx={{ color: theme.palette.text.primary }} /> : <ExpandMore sx={{ color: theme.palette.text.primary,  }} />}
                                            </ListItemButton>

                                            <Collapse  in={indexChild === selectedItemChild} timeout="auto" unmountOnExit key={indexChild}>
                                              <List component="li" disablePadding >
                                                  {item.childrens.map((item:any, index:any) => ( 
                                                    <ListItemButton 
                                                      // selected={true} // Set to true for selected state
                                                        sx={{  
                                                        padding: '4px',
                                                        margin: '2px',
                                                        borderStartEndRadius: 30,
                                                        whiteSpace: 'break-spaces', 
                                                        borderEndEndRadius: 30,
                                                        pl: 4, '&.Mui-selected': {
                                                        backgroundColor: '#765feb'
                                                        },  '&.Mui-selected:hover': {
                                                          backgroundColor: '#765feb',
                                                          color: theme.palette.common.white,
                                                          //},
                                                          // '&:hover .MuiListItemText-primary': {
                                                          // color: 'blue', // Change primary text color on hover
                                                          
                                                        },
                                                        '&.Mui-selected .MuiListItemIcon-root': {
                                                            color: theme.palette.common.white, // Change icon color when selected
                                                        },
                                                        '&.Mui-selected .MuiListItemText-primary': {
                                                          color: theme.palette.common.white, // Change primary text color when selected
                                                        }, }}  
                                                        key={index}
                                                        onClick={(event:any) => handleListItemClickChildren(event, convertIndexValue(index, indexChild))}
                                                        selected={selectedIndexChild === convertIndexValue(index, indexChild)}
                                                        component={Link}
                                                        to={item.to}>
                                                        <ListItemIcon sx={{ color: theme.palette.text.primary }} >
                                                          {/* { JSON.stringify(item) } */}
                                                          {/* CHEQUETO  */}
                                                          <IconByString iconName={item.icon}/>
                                                          {/* AQUIUIUIUIU  */}
                                                        </ListItemIcon>
                                                        <ListItemText sx={{ color: theme.palette.text.primary }}
                                                          primary={item.text} />
                                                    </ListItemButton>
                                                  ))}
                                              </List>
                                            </Collapse>
                                          </>
                                        :

                                        <ListItemButton 
                                          // selected={true} // Set to true for selected state
                                            sx={{ 
                                            padding: '4px',
                                            margin: '2px',
                                            borderStartEndRadius: 30,
                                            borderEndEndRadius: 30,
                                            pl: 4, '&.Mui-selected': {
                                            backgroundColor: '#765feb'
                                            },  '&.Mui-selected:hover': {
                                              backgroundColor: '#765feb',
                                              color: theme.palette.common.white,
                                              //},
                                              // '&:hover .MuiListItemText-primary': {
                                              // color: 'blue', // Change primary text color on hover
                                              
                                            },
                                            '&.Mui-selected .MuiListItemIcon-root': {
                                                color: theme.palette.common.white, // Change icon color when selected
                                            },
                                            '&.Mui-selected .MuiListItemText-primary': {
                                              color: theme.palette.common.white, // Change primary text color when selected
                                            }, }}  
                                            key={indexChild+2}
                                            onClick={(event:any) => handleListItemClick(event, convertIndexValue(indexChild+2, indexf))}
                                            selected={selectedIndex === convertIndexValue(indexChild+2, indexf)}
                                            component={Link}
                                            to={item.to}>
                                            <ListItemIcon sx={{ color: theme.palette.text.primary }} >
                                              {/* { JSON.stringify(item) } */}
                                              <IconByString iconName={item.icon}/>
                                              {/* AQUIUIUIUIU  */}
                                            </ListItemIcon>
                                            <ListItemText sx={{ color: theme.palette.text.primary, whiteSpace: 'break-spaces'  }}
                                              primary={item.text} />
                                        </ListItemButton>
                                      }
                                     
                                   </>
                                  
                                  
                                ))}
                            </List>
                          </Collapse>

                          
                          
                          {/* <Divider sx={{ bgcolor: "secondary.light" }}/> */}
                      </div>
                     :
                      <ListItem  key={Math.random().toString(36).substring(2,12)} disablePadding sx={{ display: 'block', }} >
                        <ListItemButton
                          key={Math.random().toString(36).substring(2,12)}
                          selected={selected}
                          onClick={ activeDashboard }
                          component={Link}
                          to={item.to}
                          sx={{
                            minHeight: 48,
                            justifyContent: open ? 'initial' : 'center',
                            px: 2.5,
                            '&.Mui-selected': {
                              backgroundColor: '#512ec2',
                              color: theme.palette.common.white
                              },  '&.Mui-selected:hover': {
                                backgroundColor: '#512ec2'
                                }
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: 0,
                              mr: open ? 3 : 'auto',
                              justifyContent: 'center',
                              color: theme.palette.text.primary
                            }}
                          >

                            {/* <IconByString iconName={item.icon} /> */}
                          </ListItemIcon>
                          <ListItemText primary={item.text} sx={{ opacity: open ? 1 : 0, whiteSpace: 'break-spaces' }} />
                        </ListItemButton>
                      </ListItem>
                  }
              </div>
            ))
          }
          
        </List>
        
      </Drawer>
  )
}